// The ids that used to be strategies, and the one they are now.
//
// Value Favourites, Optimal Legs and Consensus Edge were one idea told three
// ways: market consensus, devigged, against a price. What separated them was a
// favourites-only rule, a leg count and which book the ticket was written at —
// three knobs on one machine, printed on Today as three sections a punter had
// to choose between with nothing to choose on. They are now MARKET EDGE, and
// these are the ids their records still carry.
//
// A RECORD IS NEVER REWRITTEN. A bet placed under Optimal Legs keeps the
// `strategyId` it was placed with and the `multi.label` frozen on it — that IS
// what printed the ticket, and editing history to agree with today's catalogue
// is the app lying about its own past. What canonicalising is for is everything
// that GROUPS or NAMES: a thirty-day trail that split in two the morning
// somebody updated would be a merge nobody asked for, told as a loss of
// evidence.
//
// A LEAF. It imports nothing — not the catalogue, not the flags — so store.js,
// the engine and the pure view modules can all read it without a cycle.

/**
 * Old id → the strategy it is now. Sharp Anchor is deliberately NOT in here:
 * it is parked rather than merged (its document and its model both stay), so
 * its id still means itself and `findStrategy` still answers with it.
 */
export const STRATEGY_ALIASES = Object.freeze({
  'value-favourites': 'market-edge',
  'optimal-legs': 'market-edge',
  'consensus-edge': 'market-edge',
});

/**
 * The id a retired one has become, or the id itself.
 *
 * Anything that is not a non-empty string comes back untouched — `null` and
 * `undefined` included, because callers lean on `canonicalStrategyId(id) ??
 * CLASSIC.id` and a missing strategy is a different thing from a retired one.
 *
 * A FORK'S OWN ID IS NOT ALIASED. A fork is `optimal-legs-4f2a9c`, a document
 * of its own that somebody tuned and saved; what points at the strategy it came
 * from is its `baseId`, and that is the field callers put through here.
 */
export function canonicalStrategyId(id) {
  if (typeof id !== 'string' || !id) return id;
  // `hasOwn`, not a bare lookup: a fork could be called `toString` and the
  // prototype would hand back a function as its canonical id.
  return Object.hasOwn(STRATEGY_ALIASES, id) ? STRATEGY_ALIASES[id] : id;
}

/** True when this id is one the app has retired into another strategy. */
export const isRetiredStrategyId = (id) =>
  typeof id === 'string' && Object.hasOwn(STRATEGY_ALIASES, id);
